import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// Fires a Meta Pixel PageView on every SPA route change.
// The very first page load is already tracked by the base pixel code in
// index.html, so we skip it here to avoid double-counting.
const MetaPixelTracker = () => {
  const location = useLocation();
  const isFirstLoad = useRef(true);

  useEffect(() => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      // Fires for all initialized pixels (both IDs).
      window.fbq('track', 'PageView');
    }
  }, [location.pathname, location.search]);

  return null;
};

export default MetaPixelTracker;
